import noUiSlider from "nouislider";

export default class RangeSlider {
    filters = new Map();

    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const self = this;
        const sqftFitler = document.querySelector("#filter-sqft");
        const bedsFilter = document.querySelector("#filter-beds");
        const bathsFilter = document.querySelector("#filter-baths");
        const floorsFilter = document.querySelector("#filter-floors");

        const formReset = document.querySelector("#filter__menu__reset");

        const sqft = noUiSlider.create(sqftFitler, {
            start: [sqftFitler.dataset['minStart'], sqftFitler.dataset['maxStart']],
            step: 100,
            range: {
                'min': parseInt(sqftFitler.dataset.min),
                'max': parseInt(sqftFitler.dataset.max)
            },
            connect: true,
        });
        this.filters.set("sqft", sqft);

        const beds = noUiSlider.create(bedsFilter, {
            start: [bedsFilter.dataset['minStart'], bedsFilter.dataset['maxStart']],
            step: 0.5,
            range: {
                'min': parseFloat(bedsFilter.dataset.min),
                'max': parseFloat(bedsFilter.dataset.max)
            },
            connect: true,
        });
        this.filters.set("beds", beds);

        const baths = noUiSlider.create(bathsFilter, {
            start: [bathsFilter.dataset['minStart'], bathsFilter.dataset['maxStart']],
            step: 0.5,
            range: {
                'min': parseFloat(bathsFilter.dataset.min),
                'max': parseFloat(bathsFilter.dataset.max)
            },
            connect: true,
        });
        this.filters.set("baths", baths);

        const floors = noUiSlider.create(floorsFilter, {
            start: [floorsFilter.dataset['minStart'], floorsFilter.dataset['maxStart']],
            step: 0.5,
            range: {
                'min': parseFloat(floorsFilter.dataset.min),
                'max': parseFloat(floorsFilter.dataset.max)
            },
            connect: true,
        });
        this.filters.set("floors", floors);

        for (const [key, filter] of this.filters) {
            filter.on('slide', (values, handle) => {
                const formattedMin = Number(values[0]);
                const formattedMax = Number(values[1]);
                this.setSliderValues(formattedMin, formattedMax, key);
            });
        }

        formReset.onclick = function () {
            for (const [key, filter] of self.filters) {
                filter.set([filter.options.range.min, filter.options.range.max]);
                self.setSliderValues(filter.options.range.min, filter.options.range.max, key);
            }
        }
    }

    setSliderValues(formattedMin, formattedMax, key) {
        const min = document.querySelector(`#min_${key}`);
        const max = document.querySelector(`#max_${key}`);
        min.value = formattedMin;
        max.value = formattedMax;

        const from = document.querySelectorAll(`.${key}__from`);
        const to = document.querySelectorAll(`.${key}__to`);
        from.forEach((el) => {
            el.innerHTML = `<strong>${formattedMin.toLocaleString("en-US")}</strong>`;
        });
        to.forEach((el) => {
            el.innerHTML = `<strong>${formattedMax.toLocaleString("en-US")}</strong>`;
        });
    }
}